import type { MaybePromise } from "@reduxjs/toolkit/dist/query/tsHelpers";
import {
  createApi,
  BaseQueryApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";

//* Remove token for code
export const token =
  "eyJhbGciOiJSUzI1NiJ9.eyJsYXN0TmFtZSI6IktvbGFkZSIsIm1lcmNoYW50X2NvZGUiOiJNWDE1Nzg1IiwiZmlyc3RMb2dpbiI6ZmFsc2UsInVzZXJfbmFtZSI6Ik9sYWlkZS5Lb2xhZGUiLCJyZXF1ZXN0b3JfaWQiOiIxMjM5ODQ4NDc3MyIsImRvbWFpbl9jb2RlIjoiSVNXIiwibW9iaWxlTm8iOiIyMzQ5MDM2MTE3MzU3IiwiY2xpZW50X3R5cGUiOiJERUZBVUxUIiwiYXBwbGljYXRpb25faWQiOiI1IiwicGF5YWJsZV9pZCI6IjM2MDQ0IiwiY2xpZW50X2lkIjoiaXN3LXBvcnRhbCIsImluc3RpdHV0aW9uX2lkIjoiMjAiLCJmaXJzdE5hbWUiOiJPbGFpZGUiLCJlbWFpbFZlcmlmaWVkIjp0cnVlLCJhdWQiOlsiYW1sLXNlcnZpY2UiLCJhcGktZ2F0ZXdheSIsImFyYml0ZXIiLCJhcmJpdGVyLWlzdy1rZSIsImNhYy12ZXJpZmljYXRpb24tc2VydmljZSIsImNhZXNhciIsImVzY3Jvdy1zZXJ2aWNlIiwiaGltcy1wb3J0bGV0IiwiaXBnLXNldHRsZW1lbnQiLCJpc3ctY29sbGVjdGlvbnMiLCJpc3ctY29yZSIsImlzdy1pbnN0aXR1dGlvbiIsImlzdy1sZW5kaW5nLXNlcnZpY2UiLCJpc3ctcGF5bWVudGdhdGV3YXkiLCJreWMtc2VydmljZSIsInBhc3Nwb3J0IiwicHJvamVjdC14LWNvbnN1bWVyIiwicHJvamVjdC14LW1lcmNoYW50IiwicmVmZXJyYWwtc2VydmljZS1hcGkiLCJ0cmFuc2Zlci1zZXJ2aWNlLWNvcmUiLCJ0cmFuc2Zlci1zZXJ2aWNlLWNvcmUtYWRtaW4iLCJ0cmFuc2Zlci1zZXJ2aWNlLXBvcnRsZXQiLCJ2b3VjaGVyLWFwaSIsIndhbGxldCIsIndlYnBheS1wb3J0bGV0Il0sImNvcmVfaWQiOiIxMDAiLCJzY29wZSI6WyJwcm9maWxlIl0sImV4cCI6MTY4MjU0MzU1OSwibW9iaWxlTm9WZXJpZmllZCI6dHJ1ZSwiY2xpZW50X25hbWUiOiJJU1cgQnVzaW5lc3MgUG9ydGFsIiwianRpIjoiMjMzYzIzYzAtMGZiOS00NjE0LWJiYTctZjBhNDMwNmY3YzYwIiwiZW1haWwiOiJPbGFpZGUuS29sYWRlQGludGVyc3dpdGNoZ3JvdXAuY29tIiwicGFzc3BvcnRJZCI6IjdGOEU1OTU3LUExOTctMzhGRC1BMDA5LTBGQUUxRTBDMkJCRSJ9.etEn_YFZIxv-EmrGiPbQx2KFSpJhYvaFtTF18vy7r9kkgKfX8yJm3OwNy5x4zLmBBP1N6U2_9lqnxqcRIYflbYidfCadeUWg3MVpF95Hs_0aAOFf6cvj4bBigBNewxcBM0RU0vu2XF9VbB7fSxq_1uZmpqRJw1LCDSF3MCudgzKHgPgseiT8m2RpneEY7c4aBFLtezCc8pHqPSMcx3XZsL2mkb31diTlFOSTCr_NDKZFBdwfo0tYHnb94_GAp6X9l_uZjhZJ8TLGrAV3F4ZmrWBKfpstSTxKfvo5RkDx1y1DBt2g2Fty-a4VQqSK593T4BrWYK75TpO3lJncfHG0NA";

declare const process: { env: { [key: string]: string } };

const xsrfToken: any =
  process.env.NODE_ENV === "production" && document.getElementById("csrf-token")
    ? document.getElementById("csrf-token")?.getAttribute("content")
    : "X-XSRF-TOKEN";
const xsrfTokenHeader: any =
  process.env.NODE_ENV === "production" && document.getElementById("csrf-token")
    ? document.getElementById("csrf-header")?.getAttribute("content")
    : "X-XSRF-TOKEN";

type PickProps = "getState" | "extra" | "endpoint" | "type" | "forced";

const prepareHeaders = (
  headers: Headers,
  { getState }: Pick<BaseQueryApi, PickProps>
): MaybePromise<void | Headers> | undefined => {
  headers.set("X-Interswitch-Authorization-Domain", "ISW");

  if (headers.get("content-type") === null) {
    headers.set("content-type", "application/json");
  }

  if (headers.get("content-type") === "*") {
    headers.delete("content-type");
  }

  if (process.env.NODE_ENV !== "production") {
    headers.set("authorization", `Bearer ${token}`);
  }

  if (process.env.NODE_ENV === "production") {
    headers.set("xsrfToken", xsrfToken);
    headers.set("X-XSRF-TOKEN", xsrfToken);
    headers.set("xsrfTokenHeader", xsrfTokenHeader);
  }

  return headers;
};

export const rjTriggerApi = createApi({
  reducerPath: "RJApiSlice",
  baseQuery: fetchBaseQuery({
    baseUrl: "/nibss-batch-copy",
    prepareHeaders: prepareHeaders,
  }),
  keepUnusedDataFor: 3000,
  endpoints: () => ({}),
});

export const caesarTriggerApi = createApi({
  reducerPath: "caesarApiSlice",
  baseQuery: fetchBaseQuery({
    baseUrl: "/test",
    prepareHeaders: prepareHeaders,
  }),
  keepUnusedDataFor: 3000,
  endpoints: () => ({}),
});
